@switch (getMessageType()) {
	@case ('text') {
		{{ message?.text }}
	}
	@case ('waImageIn') {
		<img [src]="getImageUrl()" alt="WhatsApp Image" style="width: 220px; height: auto" />
		<button mat-icon-button (click)="openImageInNewWindow()" aria-label="Open image in new window">
			<mat-icon>open_in_new</mat-icon>
		</button>
		@if (message?.wa?.image?.caption) {
			{{ message?.wa?.image?.caption }}
		}
	}
	@case ('waLink') {
		{{ message?.text }}
		{{ message?.waLink }}
	}
	@case ('waImageOut') {
		<img [src]="message.waImage" alt="WhatsApp Image" style="max-width: 80px; max-height: 80px" />
	}
	@case ('waVideoIn') {
		<video [src]="getVideoUrl()" controls alt="WhatsApp Video" style="width: 220px; height: auto"></video>
		@if (message?.wa?.video?.caption) {
			{{ message?.wa?.video?.caption }}
		}
	}
	@case ('waLocation') {
		@if (message?.wa?.location?.JPEGThumbnail) {
			<img
				[src]="'data:image/jpeg;base64,' + message.wa.location.JPEGThumbnail"
				alt="Location Thumbnail"
				style="max-width: 200px; height: auto; border-radius: 8px"
			/>
			@if (message?.wa?.location?.degreesLatitude && message?.wa?.location?.degreesLongitude) {
				<button mat-icon-button (click)="openLocationInMaps()" aria-label="Open location in Google Maps">
					<mat-icon>map</mat-icon>
				</button>
			}
		}

		@if (message?.wa?.location?.name) {
			<div style="margin-top: 4px; font-weight: 500">
				{{ message.wa.location.name }}
			</div>
		}

		@if (message?.wa?.location?.address) {
			<div style="margin-top: 2px; color: #666; font-size: 0.9em">
				{{ message.wa.location.address }}
			</div>
		}

		@if (message?.wa?.location?.url) {
			<div style="margin-top: 4px">
				<a [href]="message.wa.location.url" target="_blank" style="color: #1976d2; text-decoration: none">
					<mat-icon style="vertical-align: middle; font-size: 16px">link</mat-icon>
					{{ message.wa.location.url }}
				</a>
			</div>
		}
	}
	@default {
		<div>[{{ 'COMMUNICATIONS.WHATSAPP.not_supported_wa_message' | translate | capitalize }}]</div>
	}
}
